import { render, staticRenderFns } from "./cv-select.vue?vue&type=template&id=e870e8c4&"
import script from "./cv-select.vue?vue&type=script&lang=js&"
export * from "./cv-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports